import React from 'react';
import { GlassCard } from '../../ui/Card';

const InfoSkeleton: React.FC = () => {
    return (
        <section className="section info-section-centered">
            <div className="container">
                <div className="info-grid">
                    <GlassCard>
                        <div className="skeleton-line skeleton-title" style={{ width: '60%', height: '28px', marginBottom: '20px' }}></div>
                        {[...Array(4)].map((_, i) => (
                            <div key={i} className="skeleton-line" style={{ marginBottom: '12px' }}></div>
                        ))}
                    </GlassCard>
                    <GlassCard>
                        <div className="skeleton-line skeleton-title" style={{ width: '50%', height: '28px', marginBottom: '20px' }}></div>
                        {[...Array(4)].map((_, i) => (
                            <div key={i} className="skeleton-line" style={{ marginBottom: '12px' }}></div>
                        ))}
                    </GlassCard>
                </div>
            </div>
        </section>
    );
};

export default InfoSkeleton;
